import Icon from '../components/Icon.vue'

Icon.register({
  percentage: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M109.3 173.3c-25 25-65.5 25-90.5 0-25-25-25-65.5 0-90.5s65.5-25 90.5 0 25 65.5 0 90.5zM365.3 338.7c25 25 25 65.5 0 90.5-25 25-65.5 25-90.5 0s-25-65.5 0-90.5 65.5-25 90.5 0zM363.3 107.3c12.5 12.5 12.5 32.8 0 45.3l-274.8 274.8c-12.5 12.5-32.8 12.5-45.3 0l-22.6-22.6c-12.5-12.5-12.5-32.8 0-45.3l274.8-274.8c12.5-12.5 32.8-12.5 45.3 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/percentage.js
// module id = 1630
// module chunks = 0